"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _excluded = ["target", "url", "content", "stash", "container", "unlockScreen"];
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
  var _yield$importModule, Core, _yield$importModule2, $replaceContent, $fetch, $toggleDisplay, scrollLock, $hide, $show, CN_CONTAINER, POSITION_MAP;
  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
    while (1) switch (_context5.prev = _context5.next) {
      case 0:
        _context5.next = 2;
        return importModule('Core');
      case 2:
        _yield$importModule = _context5.sent;
        Core = _yield$importModule.Core;
        _context5.next = 6;
        return importModule('Utils');
      case 6:
        _yield$importModule2 = _context5.sent;
        $replaceContent = _yield$importModule2.$replaceContent;
        $fetch = _yield$importModule2.$fetch;
        $toggleDisplay = _yield$importModule2.$toggleDisplay;
        scrollLock = _yield$importModule2.scrollLock;
        $hide = _yield$importModule2.$hide;
        $show = _yield$importModule2.$show;
        CN_CONTAINER = '@container';
        POSITION_MAP = {
          center: 'center',
          left: 'flex-start',
          right: 'flex-end',
          bottom: 'flex-end',
          top: 'flex-start'
        };
        customElements.define('modal-popup', /*#__PURE__*/function (_Core) {
          _inherits(_class2, _Core);
          var _super = _createSuper(_class2);
          function _class2() {
            var _this;
            _classCallCheck(this, _class2);
            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            _this = _super.call.apply(_super, [this].concat(args));
            _defineProperty(_assertThisInitialized(_this), "elements", {
              dialog: '[data-dialog]',
              loading: '[data-loading]',
              content: '[data-content]',
              close: '[data-close]',
              stash: '[data-stash]'
            });
            _defineProperty(_assertThisInitialized(_this), "subscriptions", {
              'modal:open': 'open',
              'modal:close': 'close',
              'modal:add-stash': '_addStash'
            });
            _defineProperty(_assertThisInitialized(_this), "defaultProps", {
              animation: 'fade',
              transition: 500,
              height: 'auto',
              width: 'auto',
              maxWidth: '100%',
              maxHeight: '100%',
              position: 'center',
              closeButton: false
            });
            _defineProperty(_assertThisInitialized(_this), "cache", {});
            _defineProperty(_assertThisInitialized(_this), "stash", {});
            _defineProperty(_assertThisInitialized(_this), "useCache", true);
            _defineProperty(_assertThisInitialized(_this), "currentTarget", void 0);
            return _this;
          }
          _createClass(_class2, [{
            key: "render",
            value: function render() {
              this.subscribe('modal:open', {
                global: true
              });
              this.subscribe('modal:close', {
                global: true
              });
              this.subscribe('modal:add-stash', {
                global: true
              });
              this._closeOnBackdropClick();
            }
          }, {
            key: "open",
            value: function () {
              var _open = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref2) {
                var target, url, content, stash, container, _ref2$unlockScreen, unlockScreen, props;
                return _regeneratorRuntime().wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      target = _ref2.target, url = _ref2.url, content = _ref2.content, stash = _ref2.stash, container = _ref2.container, _ref2$unlockScreen = _ref2.unlockScreen, unlockScreen = _ref2$unlockScreen === void 0 ? false : _ref2$unlockScreen, props = _objectWithoutProperties(_ref2, _excluded);
                      if (!(stash && !this.stash[stash])) {
                        _context.next = 3;
                        break;
                      }
                      return _context.abrupt("return");
                    case 3:
                      this.backdropHidden = unlockScreen;
                      if (this.$currentStash) {
                        $hide(this.$currentStash);
                        this.$currentStash = null;
                      }
                      if (this.$wrapper) {
                        $hide(this.$wrapper);
                      }
                      this.$wrapper = stash ? this.$stash : this.$content;
                      this._setProps(props);
                      this._setStyleProps();
                      this._setContainer(!!container);
                      this._setCloseButton();
                      scrollLock(!unlockScreen);
                      if (!stash) {
                        _context.next = 16;
                        break;
                      }
                      this._setStash(stash);
                      _context.next = 18;
                      break;
                    case 16:
                      _context.next = 18;
                      return this._setContent(target, url, content);
                    case 18:
                      this._openModal();
                    case 19:
                    case "end":
                      return _context.stop();
                  }
                }, _callee, this);
              }));
              function open(_x) {
                return _open.apply(this, arguments);
              }
              return open;
            }()
          }, {
            key: "close",
            value: function close() {
              var _this2 = this;
              if (this.$dialog.open) {
                this.$dialog.setAttribute('closing', '');
                $hide(this.$close);
                this.$dialog.addEventListener('animationend', function () {
                  scrollLock(false);
                  if (_this2.$currentStash) {
                    $hide(_this2.$currentStash);
                    _this2.$currentStash = null;
                  }
                  $hide(_this2.$wrapper);
                  _this2.$dialog.removeAttribute('closing');
                  _this2.$dialog.removeAttribute('opening');
                  _this2.$dialog.close();
                  _this2._setContainer(false);
                  $hide(_this2.$close);
                }, {
                  once: true
                });
              }
            }
          }, {
            key: "_setCloseButton",
            value: function _setCloseButton() {
              $toggleDisplay(this.$close, this.props.closeButton);
            }
          }, {
            key: "_openModal",
            value: function _openModal() {
              $show(this.$wrapper);
              if (!this.$dialog.open) {
                this.$dialog.showModal();
                this.$dialog.setAttribute('opening', '');
                // this.$dialog.addEventListener('animationend', () => {
                //     this.$dialog.removeAttribute('opening');
                // }, { once: true });
              }
            }
          }, {
            key: "_setContainer",
            value: function _setContainer(state) {
              this.$content.classList.toggle(CN_CONTAINER, state);
            }
          }, {
            key: "_setProps",
            value: function _setProps(props) {
              this.props = Object.entries(this.defaultProps).reduce(function (acc, _ref3) {
                var _ref4 = _slicedToArray(_ref3, 2),
                  key = _ref4[0],
                  val = _ref4[1];
                acc[key] = props[key] || val;
                return acc;
              }, {});
            }
          }, {
            key: "_setStyleProps",
            value: function _setStyleProps() {
              var _this$props$position$ = this.props.position.split('-'),
                _this$props$position$2 = _slicedToArray(_this$props$position$, 2),
                y = _this$props$position$2[0],
                x = _this$props$position$2[1];
              this.style.setProperty('--transition', this.props.transition + 'ms');
              this.style.setProperty('--animate-in', this.props.animation + 'In');
              this.style.setProperty('--animate-out', this.props.animation + 'Out');
              this.style.setProperty('--height', this.props.height);
              this.style.setProperty('--width', this.props.width);
              this.style.setProperty('--max-width', this.props.maxWidth);
              this.style.setProperty('--max-height', this.props.maxHeight);
              this.style.setProperty('--x', POSITION_MAP[x || y]);
              this.style.setProperty('--y', POSITION_MAP[y]);
            }
          }, {
            key: "_setStash",
            value: function _setStash(stashId) {
              this.$currentStash = this.stash[stashId];
              $show(this.$currentStash);
            }
          }, {
            key: "_addStash",
            value: function _addStash(_ref5) {
              var id = _ref5.id,
                target = _ref5.target;
              if (this.stash[id]) {
                var _this$stash$id;
                (_this$stash$id = this.stash[id]).replaceChildren.apply(_this$stash$id, _toConsumableArray(document.querySelector(target).content.cloneNode(true).childNodes));
              } else {
                var stashItem = document.createElement('div');
                var stashContent = document.querySelector(target).content.cloneNode(true);
                stashItem.setAttribute('data-stash-id', id);
                stashItem.replaceChildren.apply(stashItem, _toConsumableArray(stashContent.childNodes));
                $hide(stashItem);
                this.$stash.appendChild(stashItem);
                this.stash[id] = stashItem;
              }
            }
          }, {
            key: "_setContent",
            value: function () {
              var _setContent2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(target, url, content) {
                var cacheId, cached, $content;
                return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                  while (1) switch (_context2.prev = _context2.next) {
                    case 0:
                      if (!content) {
                        _context2.next = 3;
                        break;
                      }
                      $replaceContent(this.$content, content);
                      return _context2.abrupt("return");
                    case 3:
                      cacheId = (url || '') + target;
                      cached = this.cache[cacheId];
                      if (!(cached && this.useCache)) {
                        _context2.next = 9;
                        break;
                      }
                      _context2.t0 = cached;
                      _context2.next = 12;
                      break;
                    case 9:
                      _context2.next = 11;
                      return this._getTargetContent(target, url);
                    case 11:
                      _context2.t0 = _context2.sent;
                    case 12:
                      $content = _context2.t0;
                      if ($content) {
                        _context2.next = 16;
                        break;
                      }
                      console.error("Modal ".concat(cacheId, " target element do not exists"));
                      return _context2.abrupt("return");
                    case 16:
                      if (this.useCache && !cached) {
                        this._setCache(cacheId, $content);
                      }
                      $replaceContent(this.$content, $content);
                    case 18:
                    case "end":
                      return _context2.stop();
                  }
                }, _callee2, this);
              }));
              function _setContent(_x2, _x3, _x4) {
                return _setContent2.apply(this, arguments);
              }
              return _setContent;
            }()
          }, {
            key: "_getTargetContent",
            value: function () {
              var _getTargetContent2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(target, url) {
                var _this3 = this;
                var $doc;
                return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                  while (1) switch (_context3.prev = _context3.next) {
                    case 0:
                      if (url) {
                        _context3.next = 2;
                        break;
                      }
                      return _context3.abrupt("return", document.querySelector(target));
                    case 2:
                      _context3.next = 4;
                      return $fetch(url, {
                        before: function before() {
                          return _this3._loading(true);
                        },
                        after: function after() {
                          return _this3._loading(false);
                        },
                        select: target
                      });
                    case 4:
                      $doc = _context3.sent;
                      return _context3.abrupt("return", $doc);
                    case 6:
                    case "end":
                      return _context3.stop();
                  }
                }, _callee3);
              }));
              function _getTargetContent(_x5, _x6) {
                return _getTargetContent2.apply(this, arguments);
              }
              return _getTargetContent;
            }()
          }, {
            key: "_setCache",
            value: function _setCache(id, $content) {
              this.cache[id] = $content;
            }
          }, {
            key: "_loading",
            value: function _loading() {
              var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
              $toggleDisplay(this.$loading, state);
            }
          }, {
            key: "_closeOnBackdropClick",
            value: function _closeOnBackdropClick() {
              var _this4 = this;
              this.$dialog.addEventListener('click', function (_ref6) {
                var target = _ref6.target;
                if ((target === _this4.$dialog || target === _this4.$content) && !window.modalLock) {
                  _this4.close();
                }
              });
            }
          }, {
            key: "backdropHidden",
            set: function set(state) {
              this.toggleAttribute('unlock-screen', state);
            }
          }]);
          return _class2;
        }(Core));
        customElements.define('modal-trigger', /*#__PURE__*/function (_Core2) {
          _inherits(_class3, _Core2);
          var _super2 = _createSuper(_class3);
          function _class3() {
            _classCallCheck(this, _class3);
            return _super2.apply(this, arguments);
          }
          _createClass(_class3, [{
            key: "render",
            value: function render() {
              var _this5 = this;
              this.addEventListener('click', function (e) {
                e.preventDefault();
                _this5.publish('modal:open', {
                  target: _this5.getAttribute('target'),
                  animation: _this5.getAttribute('animation'),
                  transition: _this5.getAttribute('transition'),
                  url: _this5.getAttribute('url'),
                  position: _this5.getAttribute('position'),
                  height: _this5.getAttribute('height'),
                  width: _this5.getAttribute('width'),
                  maxWidth: _this5.getAttribute('max-width'),
                  maxHeight: _this5.getAttribute('max-height'),
                  container: _this5.hasAttribute('container'),
                  closeButton: _this5.hasAttribute('close-button'),
                  stash: _this5.getAttribute('stash')
                });
              });
            }
          }]);
          return _class3;
        }(Core));
        customElements.define('modal-close', /*#__PURE__*/function (_Core3) {
          _inherits(_class4, _Core3);
          var _super3 = _createSuper(_class4);
          function _class4() {
            _classCallCheck(this, _class4);
            return _super3.apply(this, arguments);
          }
          _createClass(_class4, [{
            key: "render",
            value: function render() {
              var _this6 = this;
              this.addEventListener('click', function () {
                _this6.publish('modal:close');
              });
            }
          }]);
          return _class4;
        }(Core));
        customElements.define('modal-load-stash', /*#__PURE__*/function (_Core4) {
          _inherits(_class5, _Core4);
          var _super4 = _createSuper(_class5);
          function _class5() {
            _classCallCheck(this, _class5);
            return _super4.apply(this, arguments);
          }
          _createClass(_class5, [{
            key: "render",
            value: function () {
              var _render = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
                return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                  while (1) switch (_context4.prev = _context4.next) {
                    case 0:
                      _context4.next = 2;
                      return customElements.whenDefined('modal-popup');
                    case 2:
                      this.publish('modal:add-stash', {
                        id: this.stashId,
                        target: this.target
                      });
                    case 3:
                    case "end":
                      return _context4.stop();
                  }
                }, _callee4, this);
              }));
              function render() {
                return _render.apply(this, arguments);
              }
              return render;
            }()
          }, {
            key: "stashId",
            get: function get() {
              return this.getAttribute('stash-id');
            }
          }, {
            key: "target",
            get: function get() {
              return this.getAttribute('target');
            }
          }]);
          return _class5;
        }(Core));
      case 19:
      case "end":
        return _context5.stop();
    }
  }, _callee5);
}))();